export default {
  PostRequest: async ({ route = "", token = "", parameters = {} }) => {
    try {
      const res = await fetch(route, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(parameters),
      });

      const data = await res.json();
      return data;
    } catch (error) {
      return;
    }
  },
  PutRequest: async ({ route = "", token = "", id = "", parameters = {} }) => {
    try {
      const res = await fetch(`${route}/${id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(parameters),
      });

      const data = await res.json();
      return data;
    } catch (error) {
      return;
    }
  },
  DeleteRequest: async ({ route = "", token = "", id = "" }) => {
    try {
      const res = await fetch(`${route}/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        if (res.status === 404) {
          // Handle Not Found error
          return {
            status: 404,
            message: "API not found !",
            data: [],
          };
        }
        if (res.status === 403) {
          // Handle Not Found error
          return {
            status: 403,
            message: "Forbidden !",
            data: [],
          };
        }
        if (res.status === 500) {
          return {
            status: 500,
            message: "Server Error !",
            data: [],
          };
        } else {
          // Handle other errors
          return {
            status: 520,
            message: "Unknown Server Error !",
            data: [],
          };
        }
      } else {
        const data = await res.json();
        return data;
      }
    } catch (error) {
      return {
        status: 520,
        message: "Unknown Error !",
        data: [],
      };
    }
  },
  GetWithOutSearchRequest: async ({
    route = "",
    token = "",
    id = "",
    searchQuery = "",
    urlParameters,
  }) => {
    try {
      const res = await fetch(`${route}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        // body: JSON.stringify(parameters),
        // body: parameters,
      });
      if (!res.ok) {
        if (res.status === 404) {
          // Handle Not Found error
          return {
            status: 404,
            message: "Zones not found !",
            data: [],
          };
        } else if (res.status === 401) {
          // Handle Not Found error
          return {
            status: 401,
            message: "Unauthorized !",
            data: [],
          };
        } else {
          // Handle other errors
          return {
            status: 520,
            message: "Unknown Error !",
            data: [],
          };
        }
      } else {
        const data = await res.json();
        return data;
      }
    } catch (error) {
      return {
        status: 520,
        message: "Unknown Error !",
        data: [],
      };
    }
  },
  GetRequest: async ({
    route = "",
    token = "",
    id = "",
    searchQuery = "",
    urlParameters = "",
  }) => {
    try {
      let path = "";
      if (id === "") {
        path = `${route}?searchQuery=${searchQuery}&${urlParameters}`;
      } else {
        path = `${route}/${id}?searchQuery=${searchQuery}&${urlParameters}`;
      }
      const res = await fetch(path, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        // body: JSON.stringify(parameters),
        // body: parameters,
      });
      if (!res.ok) {
        if (res.status === 404) {
          // Handle Not Found error
          return {
            status: 404,
            message: "Zones not found !",
            data: [],
          };
        } else if (res.status === 401) {
          // Handle Not Found error
          return {
            status: 401,
            message: "Unauthorized !",
            data: [],
          };
        } else {
          // Handle other errors
          return {
            status: 520,
            message: "Unknown Error !",
            data: [],
          };
        }
      } else {
        const data = await res.json();
        return data;
      }
    } catch (error) {
      return {
        status: 520,
        message: "Unknown Error !",
        data: [],
      };
    }
  },
};
